import React from 'react'
import Modal from 'modals/dialog'
import EntitiesClientStateProvider from 'state/entities'
import { omit } from 'utilities/object'
import { PickerContent } from 'modals/s'
import EntityPickerContent from './content'

const EntityPicker = ({ show = false, dismiss, salt, ...props }) => {
    salt = `modal:entity-picker:${salt}`
    const namespace = `${salt}:filter`

    return (
        <Modal
            show={show}
            dismiss={dismiss}
            contentWrapper={PickerContent}
            key={salt}>
            <EntityPickerContent
                {...props}
                namespace={namespace}
                salt={salt} />
        </Modal>
    )
}

export default ({ query, ...props }) => (
    <EntitiesClientStateProvider
        {...omit(query, 'key')}
        queryOptions={{
            key: query?.key,
            enabled: !props.fixed && !!query?.preload
        }}>
        <EntityPicker {...props} />
    </EntitiesClientStateProvider>
)